import { combineReducers } from 'redux';
import certificatesReducer, { fetchCertificatesPrices, selectCertificatesPrices, computeCertificateCatalogType, retrieveCertificateConfiguration, selectCertificatePrice } from './modules/certificates';
import * as certificates from './modules/certificates';
import * as disks from './modules/disks';
import disksReducer from './modules/disks';
import * as instances from './modules/instances';
import instancesReducer from './modules/instances';
import mailboxesReducer from './modules/mailboxes';
import * as mailboxes from './modules/mailboxes';
import { statePath } from './utils';
export { instances, disks };
export { mailboxes };
export { fetchMailboxesPrices, selectMailboxesPrices, selectMailboxPrice } from './modules/mailboxes';
export { certificates };
export { fetchCertificatesPrices, selectCertificatesPrices, computeCertificateCatalogType, retrieveCertificateConfiguration, selectCertificatePrice };
export { statePath };
const shsReducer = combineReducers({
  instances: instancesReducer,
  disks: disksReducer
});
export default combineReducers({
  simplehosting: shsReducer,
  mailboxes: mailboxesReducer,
  certificates: certificatesReducer
});